<template>
  <div class="form-component" :class="{ 'fullWidth': form.fullWidth }" v-if="form">
    <!-- TAB FORM -->
    <template v-if="form.tabForm">
      <div v-if="form.autosave" class="alert alert-info">
        <span class="fa fa-save fa-lg"></span> Only valid information will be autosaved.
      </div>
      <nav-tabs>
        <tab :name="tab.title" v-for="(tab, index) in form.tabs" :key="index">
          <div class="form-section-info" v-show="form.info">{{ form.info }}</div>
          <form class="form-horizontal" @submit.prevent="submitForm()" ref="form" enctype="multipart/form-data">
            <template v-if="form.disableAutofill">
              <input type="text" style="display: none;" />
              <input type="password" style="display: none;" />
            </template>
            <input type="hidden" name="permalink" :value="form.permalink" />
            <template v-for="(section, index) in tab.sections">
              <div v-if="section.html" v-html="section.html" :key="index"></div>
              <component :key="index" v-if="!section.html" :is="parseType(section)" :options="section" v-model="section.value" @input="runWatcher($event, section.name)"
                ref="fields">
              </component>
            </template>
            <transition name="expand">
              <div class="form-group row" v-show="formError">
                <div :class="form.fullWidth || isModal ? 'col-sm-12' : 'col-sm-9 offset-sm-3'">
                  <div class="alert alert-danger">
                    <i class="fa fa-exclamation-triangle"></i> {{ formError }}
                  </div>
                </div>
              </div>
            </transition>
          </form>
        </tab>
      </nav-tabs>
      <div class="form-group row" v-if="!isModal">
        <slot name="actions">
          <div class="col-sm-12 text-center">
            <button class="btn btn-success btn-lg" type="submit" @click="submitForm()">
              <i :class="'fa fa-' + form.submitIcon  + ' fa-fw'"></i> {{ form.submit }}
            </button>
          </div>
        </slot>
      </div>
    </template>
    <!-- NORMAL FORM -->
    <div :class="{ 'card': !isModal && !form.noCardView }" v-else>
      <h4 class="card-header" v-if="!isModal && !form.noCardView">
        <slot name="title"> {{ form.title }} </slot>
      </h4>
      <div :class="{ 'card-body': !isModal && !form.noCardView }">
        <div v-if="form.autosave" class="alert alert-info">
          <span class="fa fa-save fa-lg"></span> Only valid information will be autosaved.
        </div>
        <div class="form-section-info" v-show="form.info">{{ form.info }}</div>
        <form class="form-horizontal" @submit.prevent="submitForm()" ref="form" enctype="multipart/form-data">
          <template v-if="form.disableAutofill">
            <input type="text" style="display: none;" />
            <input type="password" style="display: none;" />
          </template>
          <input type="hidden" name="permalink" :value="form.permalink" />
          <template v-for="(section, index) in form.sections">
            <div v-if="section.html" v-html="section.html" :key="index"></div>
            <component :key="index" v-if="!section.html" :is="parseType(section)" :options="section" v-model="section.value" @input="runWatcher($event, section.name)"
              ref="fields">
            </component>
          </template>
          <transition name="expand">
            <div class="form-group row" v-show="formError">
              <div :class="form.fullWidth || isModal ? 'col-sm-12' : 'col-sm-9 offset-sm-3'">
                <div class="alert alert-danger">
                  <i class="fa fa-exclamation-triangle"></i> {{ formError }}
                </div>
              </div>
            </div>
          </transition>
          <div class="form-group row" v-if="!isModal">
            <slot name="actions">
              <div :class="form.fullWidth || isModal ? 'col-sm-12' : 'col-sm-9 offset-sm-3'">
                <button class="btn btn-success btn-lg" type="submit">
                  <i :class="'fa fa-' + form.submitIcon  + ' fa-fw'"></i> {{ form.submit }}
                </button>
                  <router-link
                    :to="{ path: '/forgot-password' }"
                    v-show="form.forgotPassword"
                    class="btn btn-secondary float-right"
                    style="color:white; margin-top:2px">
                    <i :class="'fa fa-key fa-fw'"></i> Forgot Password?
                  </router-link>
              </div>
            </slot>
          </div>
        </form>
      </div>
    </div>
    <div @click="autoSave()" v-if="form.autosave" id="quickSave" title="Quick Save">
      <span class="fa fa-save fa-lg"></span>
    </div>
  </div>
</template>



<script>
import NavTabs from '@/components/ui/NavTab'
import Tab from '@/components/ui/Tab'
/* global tinymce:true */
import FormSection from '@/components/FormSection.vue'
// Inputs
import AccountSelectInput from '@/components/inputs/AccountSelectInput'
import AddressInput from '@/components/inputs/AddressInput'
import AgreementInput from '@/components/inputs/AgreementInput'
import AmazonMediaInput from '@/components/inputs/AmazonMediaInput'
import AmazonMediaMultipleInput from '@/components/inputs/AmazonMediaMultipleInput'
import TrelloMultipleMediaInput from '@/components/inputs/TrelloMultipleMediaInput'
import BooleanInput from '@/components/inputs/BooleanInput'
import CalendarInput from '@/components/inputs/CalendarInput'
import CheckboxesInput from '@/components/inputs/CheckboxesInput'
import CheckboxInput from '@/components/inputs/CheckboxInput'
import MultiplePercentageInput from '@/components/inputs/MultiplePercentageInput'
import CurrencyInput from '@/components/inputs/CurrencyInput'
import DateDurationInput from '@/components/inputs/DateDurationInput'
import DiscountInput from '@/components/inputs/DiscountInput'
import DownloadInput from '@/components/inputs/DownloadInput'
import DateRangeInput from '@/components/inputs/DateRangeInput'
import DateTimeInput from '@/components/inputs/DateTimeInput'
import DateTimeRangeInput from '@/components/inputs/DateTimeRangeInput'
import DayAndMonthInput from '@/components/inputs/DayAndMonthInput'
import DayRangeInput from '@/components/inputs/DayRangeInput'
import DefectInput from '@/components/inputs/DefectInput'
import DisplayInput from '@/components/inputs/DisplayInput'
import EmailInput from '@/components/inputs/EmailInput'
import EmailsInput from '@/components/inputs/EmailsInput'
import EsmItemInput from '@/components/inputs/EsmItemInput'
import EsmPhotoInput from '@/components/inputs/EsmPhotoInput'
import HazardInput from '@/components/inputs/HazardInput'
import HiddenInput from '@/components/inputs/HiddenInput'
import MultipleTextInput from '@/components/inputs/MultipleTextInput'
import NumberInput from '@/components/inputs/NumberInput'
import ObjectSelectInput from '@/components/inputs/ObjectSelectInput'
import ObjectsSelectInput from '@/components/inputs/ObjectsSelectInput'
import OhsHazardInput from '@/components/inputs/OhsHazardInput'
import PasswordConfirmInput from '@/components/inputs/PasswordConfirmInput'
import PasswordInput from '@/components/inputs/PasswordInput'
import PercentageInput from '@/components/inputs/PercentageInput'
import PhoneInput from '@/components/inputs/PhoneInput'
import PricingInput from '@/components/inputs/PricingInput'
import PostcodeInput from '@/components/inputs/PostcodeInput'
import RadioInput from '@/components/inputs/RadioInput'
import ReportSectionsInput from '@/components/inputs/ReportSectionsInput'
import RichTextInput from '@/components/inputs/RichTextInput'
import ScottInput from '@/components/inputs/ScottInput'
import SearchInput from '@/components/inputs/SearchInput'
import StaffContributionInput from '@/components/inputs/StaffContributionInput'
import SignatureInput from '@/components/inputs/SignatureInput'
import TableSelectInput from '@/components/inputs/TableSelectInput'
import TextareaInput from '@/components/inputs/TextareaInput'
import TextInput from '@/components/inputs/TextInput'
import TextAndFileInput from '@/components/inputs/TextAndFileInput'
import TextAndFileMultipleInput from '@/components/inputs/TextAndFileMultipleInput'
import TextSelectInput from '@/components/inputs/TextSelectInput'
import TextsSelectInput from '@/components/inputs/TextsSelectInput'
import TimeInput from '@/components/inputs/TimeInput'
import UrlInput from '@/components/inputs/UrlInput'
import UsernameInput from '@/components/inputs/UsernameInput'
import ObjectSelectAndFileInput from '@/components/inputs/ObjectSelectAndFileInput'
import dom from '@/util/dom'
import GitLabMediaMultipleInput from '@/components/inputs/GitLabMediaMultipleInput'
import {
  OPEN_ERROR_MODAL,
  SUBMIT_FORM,
  LOAD_FORM,
  OPEN_CONFIRMATION_MODAL,
  CLOSE_FORM
} from '@/vuex/types'
import { mapGetters } from 'vuex'

export default {
  name: 'VueForm',
  components: {
    ObjectSelectAndFileInput,
    AccountSelectInput,
    AddressInput,
    AgreementInput,
    AmazonMediaInput,
    AmazonMediaMultipleInput,
    BooleanInput,
    CalendarInput,
    CheckboxesInput,
    CheckboxInput,
    CurrencyInput,
    DateDurationInput,
    DiscountInput,
    DayAndMonthInput,
    DownloadInput,
    DateRangeInput,
    DateTimeInput,
    DateTimeRangeInput,
    DayRangeInput,
    DisplayInput,
    DefectInput,
    EmailInput,
    EmailsInput,
    EsmItemInput,
    EsmPhotoInput,
    FormSection,
    HazardInput,
    HiddenInput,
    MultipleTextInput,
    NavTabs,
    NumberInput,
    ObjectSelectInput,
    ObjectsSelectInput,
    OhsHazardInput,
    PasswordConfirmInput,
    PasswordInput,
    PercentageInput,
    PhoneInput,
    PricingInput,
    PostcodeInput,
    RadioInput,
    ReportSectionsInput,
    RichTextInput,
    ScottInput,
    SearchInput,
    SignatureInput,
    StaffContributionInput,
    Tab,
    TableSelectInput,
    TextareaInput,
    TextInput,
    TextAndFileInput,
    TextAndFileMultipleInput,
    TextSelectInput,
    TextsSelectInput,
    TimeInput,
    UrlInput,
    UsernameInput,
    GitLabMediaMultipleInput,
    TrelloMultipleMediaInput,
    MultiplePercentageInput
  },
  props: {
    options: {
      type: Object,
      default () {
        return {
          permalink: false,
          title: 'Loading Form...',
          submit: 'Loading...',
          submitting: 'Processing...',
          confirmation: false,
          redirect: '/',
          params: false,
          disableAutofill: false,
          saving: false
        }
      }
    },
    sections: {
      type: Array,
      default () {
        return []
      }
    },
    isModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      watchers: [],
      validForm: false,
      formError: false,
      sending: false,
      loadedForm: false,
      autoSaver: '',
      validating: false
    }
  },
  computed: {
    form () {
      if (this.loadedForm) {
        return this.$store.getters.getForm(this.loadedForm)
      } else {
        return { ...this.options, sections: this.sections }
      }
    },
    meta () {
      let info = Array.from(this.$route.matched).reverse().find(m => m.meta.authType)
      return info.meta
    },
    ...mapGetters([
      'expiredSession'
    ])
  },
  watch: {
    async $route () {
      this.loadedForm = false
      let permalink = this.options.permalink || this.$route.meta.vueForm
      this.$store.commit(CLOSE_FORM, permalink)
      let params = {
        ...this.options.params,
        ...this.$route.params
      }
      if (permalink && this.options.method !== 'search') {
        let { meta } = Array.from(this.$route.matched).reverse().find(m => m.meta.authType)
        try {
          await this.$store.dispatch(LOAD_FORM, {
            permalink,
            params,
            auth: meta.authType
          })
          this.loadedForm = permalink
          await this.$nextTick()
          // attach listeners
          let watchers = []
          if (this.form && !this.form.tabForm) {
            for (let child of this.$children) {
              if (child.options && child.options.watchers) {
                for (let watcher of child.options.watchers) {
                  if (!Array.isArray(watchers[watcher])) watchers[watcher] = []
                  watchers[watcher].push({
                    el: child,
                    name: watcher
                  })
                }
              }
            }
          } else {
            for (let child of this.$children) {
              for (let tab of child.tabs) {
                for (let tabChild of tab.$children) {
                  if (tabChild.options && tabChild.options.watchers) {
                    for (let watcher of tabChild.options.watchers) {
                      if (!Array.isArray(watchers[watcher])) watchers[watcher] = []
                      watchers[watcher].push({
                        el: tabChild,
                        name: watcher
                      })
                    }
                  }
                }
              }
            }
          }
          this.watchers = watchers
          this.$emit('load')
        } catch (err) {
          this.$store.dispatch(OPEN_ERROR_MODAL, err)
        }
      }
    }
  },
  async mounted () {
    let permalink = this.options.permalink || this.$route.meta.vueForm
    this.$store.commit(CLOSE_FORM, permalink)
    let params = {
      ...this.options.params,
      ...this.$route.params,
      ...this.$route.query
    }
    if (permalink && this.options.method !== 'search') {
      let { meta } = Array.from(this.$route.matched).reverse().find(m => m.meta.authType)
      try {
        await this.$store.dispatch(LOAD_FORM, {
          permalink,
          params,
          auth: meta.authType
        })
        this.loadedForm = permalink
        await this.$nextTick()
        let watchers = []
        if (this.form && !this.form.tabForm) {
          for (let child of this.$children) {
            if (child.options && child.options.watchers) {
              for (let watcher of child.options.watchers) {
                if (!Array.isArray(watchers[watcher])) watchers[watcher] = []
                watchers[watcher].push({
                  el: child,
                  name: watcher
                })
              }
            }
          }
        } else {
          for (let child of this.$children) {
            for (let tab of child.tabs) {
              for (let tabChild of tab.$children) {
                if (tabChild.options && tabChild.options.watchers) {
                  for (let watcher of tabChild.options.watchers) {
                    if (!Array.isArray(watchers[watcher])) watchers[watcher] = []
                    watchers[watcher].push({
                      el: tabChild,
                      name: watcher
                    })
                  }
                }
              }
            }
          }
        }
        this.watchers = watchers
        this.$emit('load')
      } catch (err) {
        this.$store.dispatch(OPEN_ERROR_MODAL, err)
      }
    }
    if (this.form.autosave) {
      this.autoSaver = setInterval(this.autoSave, 25 * 60 * 1000) // 25 minutes
    }
  },
  beforeDestroy () {
    clearInterval(this.autoSaver)
  },
  methods: {
    async autoSave () {
      if (!this.saving) {
        this.saving = true
        tinymce.triggerSave()
        await this.validateForm()
        let form = { elements: this.$refs.fields }
        // serializeForm will only serialize valid fields -
        // invalid will not be posted
        let validFormData = dom(form).serializeForm()
        try {
          await this.$store.dispatch(SUBMIT_FORM, {
            data: { ...validFormData, permalink: this.form.permalink + 'QuickSave' },
            method: this.meta.vueFormMethod,
            auth: this.meta.authType,
            reload: this.form.reload || false
          })
        } catch (err) {
          console.log('error auto saving')
        } finally {
          this.saving = false
        }
      }
    },
    async submitForm (e) {
      clearInterval(this.autoSaver)
      this.sending = true
      await this.validateForm()
      if (this.validForm) {
        tinymce.triggerSave()
        let formData = this.serializeForm()
        let method = this.options.method || this.$route.meta.vueFormMethod
        this.formError = false
        formData.params = this.$route.params
        this.options.submit = this.options.submitting
        try {
          await this.$store.dispatch(SUBMIT_FORM, {
            data: formData,
            method,
            auth: this.meta.authType,
            reload: this.form.reload || false
          })
          this.sending = false
          if (this.form && this.form.confirmation) {
            this.$store.dispatch(OPEN_CONFIRMATION_MODAL, this.form)
          } else if (this.options.redirect) {
            this.$router.push(this.options.redirect)
            this.$emit('complete')
          } else if (this.form && this.form.redirect) {
            this.$router.push(this.form.redirect)
            this.$emit('complete')
          } else {
            this.$emit('complete')
          }
        } catch (err) {
          this.$store.dispatch(OPEN_ERROR_MODAL, err)
        }
      } else {
        for (let input in this.$children) {
          let $input = this.$children[input]
          if ($input.field) {
            $input.field.dirty = true
          }
        }
        this.formError = 'You did not fill all fields correctly'
      }
      this.sending = false
    },
    serializeForm () {
      let form = { elements: this.$refs.fields }
      let formData = dom(form).serializeForm()
      return { ...formData, permalink: this.form.permalink }
    },
    async validateForm () {
      let validForm = true
      this.validating = true
      for (let el of this.$refs.fields) {
        if (el.options.type === 'number' && el.options.value === '') {
          el.options.value = null
        }
        if (el.options.required || el.required || !el.isValid) {
          await el.validate()
          if (validForm) {
            validForm = el.isValid
          }
        }
      }
      this.validating = false
      this.validForm = validForm
    },
    parseType ({ type, objectType }) {
      switch (type) {
        case 'form-section':
          return 'form-section'
        case 'loose-search':
        case 'object':
        case 'array':
        case 'relation':
          if (objectType) {
            return `${objectType}-input`
          } else {
            return 'search-input'
          }
        case 'price-breakdown':
          return 'price-breakdown'
        default:
          return type + '-input'
      }
    },
    runWatcher (val, name) {
      if (!this.validating) {
        if (!this.sending) {
          this.$emit('updated')
        }
        for (let watcherName in this.watchers) {
          let section
          if (this.form.tabForm) {
            for (let tab of this.form.tabs) {
              if (!section) section = tab.sections.find(el => el.name === name)
            }
          } else {
            section = this.form.sections.find(el => el.name === name)
          }
          for (let watcher of this.watchers[watcherName]) {
            watcher.el.runWatcher(section.value, section.name)
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Form.vue